import React from "react";

const TakeAway = (props) => {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "1em"}
      height={height ?? "1em"}
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none">
        <path d="M19.781 14.555L13.5 16h-.375a1.875 1.875 0 0 0 0-3.75H8.438a2.25 2.25 0 0 0-1.594.656L4.5 15.25v5.25h6.75l6-1.5l3.64-1.552a1.555 1.555 0 0 0-1.109-2.893M4.5 15.25v5.25H1v-5.25zM16.5 3h-4v5l2-1l2 1z" />
        <path
          stroke="currentColor"
          strokeLinecap="square"
          strokeWidth="2"
          d="M4.5 20.5h6.75l6-1.5l3.64-1.552a1.555 1.555 0 0 0-1.109-2.893L13.5 16h-.375M4.5 20.5v-5.25m0 5.25H1v-5.25h3.5m0 0l2.344-2.344a2.25 2.25 0 0 1 1.593-.656h4.688a1.875 1.875 0 0 1 0 3.75H11M8.5 8.5V3h12v7.5m-8-7.5h4v5l-2-1l-2 1z"
        />
      </g>
    </svg>
  );
};

export default TakeAway;
